import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { LineUpService, TshirtStyle } from '../../../../lineup/services/lineup-service';
import { TournamentService } from '../../../services/tournament.service';
import { SportAlgoUtils } from '../../../services/sport.algo';

@Component({
  selector: 'edit-ko',
  templateUrl: 'edit-ko.html',
})
export class ResultEditKoPage {
  activePlan: any;
  ti: any;
  results = ["0", "0"];
  points = ["0", "0"];
  changeDetector: boolean = false;

  constructor(
    private navParams: NavParams,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,
    public gs: TournamentService,
    private ls: LineUpService
  ) { }

  ionViewDidLoad() {
    this.activePlan = this.navParams.get('activePlan');
    this.ti = this.navParams.get('teamIndex');
    this.results = this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].results.split('-');
    this.points = this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].points.split('-')
  }

  onChangeTeam(index) {
    this.toastCtrl.create({
      duration: 5000,
      position: 'top',
    }).present();
  }


  onSave() {
    this.gs.save();
  }

  getWinner() {
    if (this.points[0] > this.points[1]) {
      return 1;
    } else if (this.points[0] < this.points[1]) {
      return 2;
    } else {
      return 0;
    }
  }

  getMultiplicator(winner, team) {
    if (winner == 0) return this.gs.counters.tieScore;

    if (team == 1) {
      return (winner == 1) ? this.gs.counters.winScore : this.gs.counters.lossScore;
    } else if (team == 2) {
      return (winner == 2) ? this.gs.counters.winScore : this.gs.counters.lossScore;
    }
  }

  onPointsChange(teamIndex: string, value: any) {
    let teamId = this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j][teamIndex].id;
    let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
    let winner = this.getWinner();
    if(winner > -1) this.points[winner] = value + "";
    this.assignNextTeam(arrIndex);
    this.onSetWinner(winner);
  }

  async teamClick(winnerIndex: number) {
    let team = (winnerIndex % 2) ? 'team2' : 'team1';
    let teamId = this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j][team].id;
    let arrIndex = this.gs.planList[this.activePlan].teams.findIndex(x => x.id === teamId);
    this.points[winnerIndex] = this.gs.counters.winScore + "";
    this.assignNextTeam(arrIndex);
    this.onSetWinner(winnerIndex);
  }

  async assignNextTeam(arrIndex: number) {
    if (typeof this.gs.planList[this.activePlan].gameTable[this.ti.i + 1] != "undefined") {
      let team = (this.ti.j % 2) ? 'team2' : 'team1';
      if (!this.gs.planList[this.activePlan].gameTable[this.ti.i + 1][Math.floor(this.ti.j / 2)][team]) {
        this.gs.planList[this.activePlan].gameTable[this.ti.i + 1][Math.floor(this.ti.j / 2)][team] = this.gs.planList[this.activePlan].teams[arrIndex];
      }
    }
  }

  onSetWinner(winnerIndex: number) {
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].played = true;
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].winner = winnerIndex;
    this.changeDetector = true;
    this.gs.save();
  }

  checkCompletion() {
    for (let i = 0; i < this.gs.planList[this.activePlan].gameTable.length; i++) {
      for (let j = 0; j < this.gs.planList[this.activePlan].gameTable[i].length; j++) {
        this.gs.planList[this.activePlan].roundPhase = this.gs.planList[this.activePlan].gameTable[i][j].played;
      }
    }
  }

  update() {
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team1.points += Number(this.points[0]);
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team2.points += Number(this.points[1]);;
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team1.results += Number(this.results[0]);
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].team2.results += Number(this.results[1]);
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].points = this.points[0] + "-" + this.points[1];
    this.gs.planList[this.activePlan].gameTable[this.ti.i][this.ti.j].results = this.results[0] + "-" + this.results[1];
    this.gs.save();
    this.gs.saveTou(this.gs.planList[this.activePlan]).then(plan => {
        this.gs.planList[this.activePlan] = plan;
    });
  }

  createTeam() {
   return {
      id: new Date().getTime(),
      name: '',
      results: 0,
      points: 0,
      players: [],
      activity: {
        name: 'Football',
        path: 'football'
      },
      tshirt: {
        type: this.ls.field.type,
        style: TshirtStyle.colored,
        color1: "#ffbf00",
        color2: "#000000"
      }
    };
  }

  onClose() {
    if (this.changeDetector) this.update();
    this.viewCtrl.dismiss();
  }

}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/edits/ko-page/edit-ko.ts